import { render } from "./AudioObject.vue?vue&type=template&id=552c8cee&scoped=true"
import script from "./AudioObject.vue?vue&type=script&lang=js"
export * from "./AudioObject.vue?vue&type=script&lang=js"

import "./AudioObject.vue?vue&type=style&index=0&id=552c8cee&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552c8cee"]])

export default __exports__